import { useQuery } from '@tanstack/react-query';
import { InvitationPanel, useToast } from '@rooming/ui';
import { useInvitationSharing } from '@rooming/web-core';
import { backoffice } from '../api';

// The passengers' site is the same address without «-admin» (rooming.funtour.cl / rooming-admin.funtour.cl); used only
// when the server has no site address configured.
const PASSENGER_SITE = `${window.location.protocol}//${window.location.host.replace(/^rooming-admin\./, 'rooming.')}`;

/** The guide shares the group's activation link from the top of their view (DR-405). Renders nothing until it knows. */
export function GroupInvitation({ groupId }: { readonly groupId: string }) {
  const toast = useToast();
  const invitation = useQuery({
    queryKey: ['activation-invitation', groupId],
    queryFn: () => backoffice.activationInvitation(groupId),
  });
  const { closesOnText, share, copy } = useInvitationSharing(invitation.data, PASSENGER_SITE, toast);
  if (invitation.data === undefined) return null;
  return (
    <div className="mb-5">
      <InvitationPanel
        open={invitation.data.open}
        closedReason={invitation.data.closedReason}
        total={invitation.data.total}
        pending={invitation.data.pending}
        closesOnText={closesOnText}
        onShare={share}
        onCopy={copy}
      />
    </div>
  );
}
